import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import UsersContainer from '../containers/Users';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { permissions } from '../components/pureForm/PermissionPicker';

const permissionMap = {};
permissions.forEach(({ id, display }) => {
	permissionMap[id] = display;
});

const styles = () => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
	},
	sectionHeader: {
		textTransform: 'uppercase',
		fontSize: 14,
		color: '#777',
		fontWeight: 900,
		letterSpacing: 2,
		marginTop: 30,
		marginBottom: 10,
	},
	testBody: {
		border: '1px solid #ddd',
		padding: 10,
	},
	bodyPre: {
		whiteSpace: 'pre-wrap',
	},
	dialogPaper: {
		maxWidth: 1000,
		overflow: 'scroll',
	},
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
});

const columnData = [
	{ id: 'firstName', numeric: false, label: 'First Name' },
	{ id: 'lastName', numeric: false, label: 'Lats Name' },
	{ id: 'email', numeric: false, label: 'Email' },
	{ id: 'role', numeric: false, label: 'Role' },
	{ id: 'permissions', numeric: false, label: 'Permissions' },
	{ id: 'hasMobile', numeric: false, label: 'Mobile' },
	{ id: 'edit', numeric: false, label: 'Edit' },
];

const roleToDisplay = {
	employee: 'Pearson Employee',
	externalLogistics: 'External Logistics',
	externalReporting: 'External Reporting',
	mxhApiAccess: 'MHX API Access',
};

class Users extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	componentDidMount() {
		if (!this.props.users.length) {
			this.props.searchUsers();
		}
	}

	handleEdit = (userId) => {
		this.props.history.push(`/user/update/${userId}`);
	};

	render() {
		const { classes, users, authUser } = this.props;

		if (!authUser) {
			return null;
		}

		const canViewUsers = _.get(authUser, ['permissions', 'canViewUsers']);
		if (!canViewUsers) {
			return <div>INVALID PERMISSIONS! GET OUTTA HERE!</div>;
		}

		//const { classes, notificationJobs, stationMap } = this.props;
		const { order, orderBy } = this.props;

		return (
			<div style={{ width: '100%' }}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<div>
							<Grid container spacing={3}>
								<Grid item xs={6}>
									<Typography variant="h5" align="left" gutterBottom>
										Users
									</Typography>
								</Grid>
							</Grid>
							<Paper className={classes.paper}>
								<div style={{ padding: 20 }}>
									<Table size={'small'}>
										<TableHead>
											<TableRow>
												{columnData.map((column) => {
													return (
														<TableCell key={column.id} align={column.numeric ? 'right' : 'left'}>
															<TableSortLabel active={orderBy === column.id} direction={order}>
																{column.label}
															</TableSortLabel>
														</TableCell>
													);
												}, this)}
											</TableRow>
										</TableHead>
										<TableBody>
											{users.map((user) => {
												/** @namespace user.userId **/
												return (
													<TableRow hover className={classes.row} key={user.userId}>
														<TableCell>{user.firstName}</TableCell>
														<TableCell>{user.lastName}</TableCell>
														<TableCell>{user.email}</TableCell>
														<TableCell>{roleToDisplay[user.role] || 'Missing'}</TableCell>
														<TableCell>
															{_.keys(user.permissions).map((permission) => {
																return (
																	<div key={permission}>
																		{permissionMap[permission] || 'MISSING'}
																	</div>
																);
															})}
														</TableCell>
														<TableCell>{user.mobilePhoneNumber ? '✅' : '-'}</TableCell>
														<TableCell style={{ whiteSpace: 'nowrap' }}>
															<Button
																className={classes.button}
																onClick={() => this.handleEdit(user.userId)}
															>
																Edit
															</Button>
														</TableCell>
													</TableRow>
												);
											})}
										</TableBody>
									</Table>
								</div>
							</Paper>
						</div>
					</Grid>
				</Grid>
			</div>
		);
	}
}

Users.propTypes = {
	classes: PropTypes.object.isRequired,
	users: PropTypes.array,
	searchUsers: PropTypes.func.isRequired,
	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), UsersContainer])(Users);
